<template>
  <div id="container">
    <div class="logoBox">
      <img src="@/assets/logo_text.svg" alt="" />
    </div>
    <div class="error">
      <div>
        <img src="~@/assets/img/etc/icon_errorpage.svg" class="mb18" />
        <div class="text01" v-html="nl2br(message.top)"></div>
        <div class="mid-content">
          <div v-html="nl2br(message.mid)"></div>
        </div>
        <div class="text01" v-html="nl2br(message.bottom)"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      top: "",
      mid: "",
      bottom: "",
    },
  },
  created() {
    this.socketInit();
  },
  methods: {
    nl2br(str) {
      return str.replace(/\n/g, "<br />");
    },
    socketInit() {
      const checkDevServer =
        window.location.href.includes("dev.") ||
        window.location.href.includes("local.");
      const SOKET_URL_DEV = `wss://ws.dev.flybit.com/io`;
      const SOKET_URL_LIVE = `wss://ws.flybit.com/io`;
      const PINGPONG_INTERVAL = 30000;
      const _this = this;
      const socket = checkDevServer
        ? new WebSocket(SOKET_URL_DEV)
        : new WebSocket(SOKET_URL_LIVE);
      // const socket = new WebSocket(SOKET_URL_LIVE);

      let ping;
      const pingpong = () => {
        const sendPingPongData = { channel: "ping" };
        socket.send(JSON.stringify(sendPingPongData));
        ping = setTimeout(pingpong, PINGPONG_INTERVAL);
      };

      const socketInfo = {
        channel: "eventSub",
        data: {
          events: [""],
          id: 0,
          mkidx: [], // TradeCM 구독용, 빈칸은 전체구독
          mkname: [], // TradeInit 구독용
        },
      };
      socket.addEventListener("open", function(event) {
        socket.send(JSON.stringify(socketInfo));
        ping = setTimeout(pingpong, PINGPONG_INTERVAL);
      });

      socket.addEventListener("message", async function(event) {
        const blobParse = await new Blob([event.data], {
          type: "text/plain",
        }).text();
        const data = JSON.parse(blobParse);
        const setSocketEvent = (lastMessage) => {
          const { event } = lastMessage;
          const { result } = lastMessage;
          if (event === "update") {
            // 서버점검
            if (result.event === "server") {
              location.replace("/");
              Store.commit("SET_SERVER_STATUS", false);
              Store.commit("SET_SERVER_MESSAGE", lastMessage);
              return;
            }
            // 새로고침
            else if (result.event === "refresh") {
              const tempSocketInfo = {
                channel: "eventUnSub",
                data: {
                  events: [""],
                  id: 0,
                  mkidx: [], // TradeCM 구독용, 빈칸은 전체구독
                  mkname: [], // TradeInit 구독용
                },
              };
              socket.send(JSON.stringify(tempSocketInfo));

              window.location.reload();
            }
            // 에러이벤트
            else if (event === "error") {
              console.log("error");
            }
          }
        };
        setSocketEvent(data);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "/src/styles/import.scss";

p {
  margin-bottom: 0;
}
.logoBox {
  padding: 24px;
  img {
    width: 100px;
  }
}
.error {
  padding: 80px 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.text01 {
  color: $WarmBlack700;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 24px;
}
.mid-content {
  width: fit-content;
  text-align: left;
  margin: 0 auto 24px;
}
</style>
